export default __webpack_public_path__ + "8d8f565353b6ca5598e24bcfa47de3a5.svg";